import { useEffect, useState } from 'react'
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, TextField,
} from '@mui/material'

export default function Beacon4PerformanceNetworkOverviewAdminConfirmDialog({
  open, title, message,
  confirmLabel = 'Confirm', confirmColor = 'primary',
  withNote = false, notePlaceholder = 'Optional note',
  busy = false, onConfirm, onClose,
}) {
  const [note, setNote] = useState('')
  useEffect(() => { if (open) setNote('') }, [open])

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: 14, fontWeight: 600 }}>{title}</DialogTitle>
      <DialogContent>
        {message && (
          <DialogContentText sx={{ fontSize: 12, color: 'text.secondary' }}>
            {message}
          </DialogContentText>
        )}
        {withNote && (
          <TextField
            autoFocus fullWidth size="small" multiline minRows={2}
            label="Note (audit log)" placeholder={notePlaceholder}
            value={note} onChange={e => setNote(e.target.value)}
            sx={{ mt: 2 }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose} disabled={busy}>Cancel</Button>
        <Button size="small" variant="contained" color={confirmColor} disabled={busy}
          onClick={() => onConfirm(note)}>
          {busy ? 'Working…' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}